var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"e-toolbar-button",class:{ active: _vm.action.isActive },attrs:{"id":_vm.action.key,"data-toolbar":"button"},on:{"click":function($event){$event.preventDefault();return _vm.action.call.apply(null, arguments)}}},_vm.listeners),[_c('e-svg-icon',{attrs:{"name":_vm.action.icon,"size":"xmd"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }